// Angular
import { InjectionToken } from '@angular/core';

export const CONSTANTS = new InjectionToken('constants');

export const constants = {
	// Standard structure for constants per page. Those includes a route (for use in routerLink),
	// a page for use in analytics, and sometimes session control flag and percentage of advance.

	APP_STORE_SOURCE_PAGE: {
		MOBILE_AD_MODAL: 'MOBILE_AD_MODAL',
		BOARDING_PASS: 'BOARDING_PASS'
	},
	APP_STORE_URL: {
		ROYAL: {
			MOBILE_AD_MODAL: {
				IOS:
					'https://rcc.app.link/AppStore',
				ANDROID:
					'https://rcc.app.link/GooglePlayStore',
				UNIFIED:
					'https://rcc.app.link/download'
			},
			BOARDING_PASS: {
				IOS:
					'https://c00.adobe.com/v3/82ab4bf1827d27e9180ba79a5df2cd0cbefd0180952a64482071f2673e65be31/start?a_dl=5c5b2d28f2ccba90e14994e1',
				ANDROID:
					'https://c00.adobe.com/v3/82ab4bf1827d27e9180ba79a5df2cd0cbefd0180952a64482071f2673e65be31/start?a_dl=5c5b2eb9f2ccba90e14994eb'
			}
		},
		CELEBRITY: {
			MOBILE_AD_MODAL: {
				IOS:
					'https://cel.app.link/AppStore',
				ANDROID:
					'https://cel.app.link/GooglePlayStore',
				UNIFIED:
					'https://cel.app.link/download'
			},
			BOARDING_PASS: {
				IOS:
					'https://c00.adobe.com/v3/82ab4bf1827d27e9180ba79a5df2cd0cbefd0180952a64482071f2673e65be31/start?a_dl=5c5b3edbf2ccba90e1499544',
				ANDROID:
					'https://c00.adobe.com/v3/82ab4bf1827d27e9180ba79a5df2cd0cbefd0180952a64482071f2673e65be31/start?a_dl=5c5b3f4cf2ccba90e149954a'
			}
		}
	},
	BRANDS_NAMES: {
		ROYAL: 'royal',
		CELEBRITY: 'celebrity'
	},
	BOARDING_PASS_COUNTRY_EXCEPTION: {
		CHINA: 'CHINA'
	},
	BOARDING_PASS_CHINA_BARCODE_MESSAGE: `出入境通关条形码 For official use only`,
	BOARDING_PASS_OUTSTANDING_BALANCE_ERROR: 'Booking not paid in full.',
	BOOKING_OFFICE: {
		MIA: 'MIA',
		LON: 'LON'
	},
	CARD_TYPE: {
		AMEX: 'AX',
		MASTERC: 'MC',
		VISA: 'VI',
		DISCOVER: 'DI',
		JCB: 'JC',
		DINERS_CLUB: 'DC',
		CARTE_BLANCHE: 'CB'
	},
	CONSENTS_DOCUMENTS_TYPE: {
		CTC: 'RESERVATION_CONTRACT',
		BIOMETRIC: 'BIOMETRIC_CONSENT',
		FACIAL: 'FACIAL_BIO_CONSENT',
		PHOTO_GRANTEE: 'PHOTO_BIO_CONSENT_GRANTEE',
		PHOTO_GRANTOR: 'PHOTO_BIO_CONSENT_GRANTOR',
		FACIAL_GRANTEE: 'FACIAL_BIO_CONSENT_GRANTEE',
		FACIAL_GRANTOR: 'FACIAL_BIO_CONSENT_GRANTOR',
		HQ1: 'HQ1',
		HQ2: 'HQ2',
		RAC: 'HEALTH_RISK_ACKNOWLEDGEMENT'
	},
	COOKIES: {
		GA: {
			WUC_NONPROD: 'wuc_nonprod',
			WUC: 'wuc',
			WUL_NONPROD: 'wul_nonprod',
			WUL: 'wul'
		},
		OLCI: {
			ACCESS_TOKEN: 'accessToken',
			ID_TOKEN: 'idToken',
			LOYALTY_DATA: 'loyaltyData',
			PLANET_DIRECTORY: 'iPlanetDirectoryPro',
			J_SESSION_ID: 'JSESSIONID',
			TEALEAF_SESSION_ID: 'TealeafSessionId',
			CPE: 'CPE',
			OLCI_DATA: 'olciData',
			CHECKIN_DATA: 'checkinData',
		}
	},
	COUNTRIES_DEFAULT: ['USA', 'GBR', 'CHN', 'AUS', 'CAN'],
	COUNTRY_CODES: {
		USA: 'USA'
	},
	CRUISE_SURVEY: {
		NOT_ANSWERED: 'NOT_ANSWERED',
		YES: 'YES',
		NO: 'NO'
	},
	DATE_FORMAT: {
		DAY_FIRST: ['MEX', 'BRA', 'ESP', 'GBR', 'AUS', 'NZL', 'CAN'],
		INTERNATIONAL: 'int',
		USA: 'us',
		SERVER: 'YYYY-MM-DD',
		DATEPICKER: 'MM-D-YYYY',
		GUEST_ACCOUNT: 'MM/DD/YYYY',
		MICROSERVICE: 'YYYYMMDD',
		MONTHS_YEAR: 'MM/YYYY'
	},
	DEEP_LINK_APP_URL: {
		ROYAL: 'https://www.royalcaribbean.com/appcheckin',
		CELEBRITY: 'https://www.celebritycruises.com/appcheckin'
	},
	DEFAULT_YEAR: 1900,
	DEFAULT_GUEST_ID_FOR_TRACKING: {
		ID: '00000000'
	},
	DEVICE_TYPE: {
		IPHONE: 'IPHONE',
		IPAD: 'IPAD',
		ANDROID: 'ANDROID',
		DESKTOP: 'DESKTOP'
	},
	DOCUMENT_TYPES: {
		ENHANCED_DRIVER_LICENSE: 'L',
		AUSTRALIA_DRIVER_LICENSE: 'U',
		AUSTRALIA_BIRTH_CERTIFICATE: 'B',
		AUSTRALIA_BIRTH_CERTIFICATE_NO_DOCUMENT: 'BN'
	},
	EMPTY_CONTENT_TOKEN: null,
	ENVIRONMENTS_VALUES: {
		LOCAL: 'local',
		DEVELOPMENT: 'dev',
		TEST: 'test',
		TEST_ALTERNATE: 'tst',
		STAGE: 'stage',
		STAGE_ALTERNATE: 'stg',
		PRODUCTION: 'prod',
		PROD_ALTERNATE:'production'
	},
	ERROR_MESSAGES: {
		ERROR_OLCI_DATA_COOKIE: 'olciData cookie has null values'
	},
	EXPENSE_PAYMENT_PARAMETERS: [
		{
			type: 'VI',
			name: 'Visa'
		},
		{
			type: 'DI',
			name: 'Discover (R) Network'
		},
		{
			type: 'MC',
			name: 'Master Card'
		},
		{
			type: 'AX',
			name: 'American Express'
		},
		{
			type: 'JC',
			name: 'JCB'
		},
		{
			type: 'DC',
			name: 'Diners Club'
		}
	],
	FORM_VALIDATIONS: {
		MAX_CHARACTERS: 25
	},
	GUEST_ADDRESSES_TYPES: {
		PRE_ADDRESS: 'PRE_ADDRESS',
		POST_ADDRESS: 'POST_ADDRESS',
		RESIDENTIAL_ADDRESS: 'RESIDENTIAL_ADDRESS'
	},
	HOME: {
		ROUTE: '/',
		page: 'home' // The 'page' name is used in the analytics. Don't change these names after we go live.
	},
	HTTP_STATUS_CODE: {
		SUCCESS: 200,
		BAD_REQUEST: 400,
		UNAUTHORIZED_ERROR: 401,
		NOT_FOUND: 404,
		BACKEND_ERROR: 500,
		UNKNOWN_ERROR: 600
	},
	IMMIGRATION_DATA_VISIBLE: {
		IS_BIRTH_CERTIFICATE: ['BD', 'BM', 'BT', 'BS', 'RD', 'RM', 'RT', 'RS', 'RN', 'BN', 'B'],
		IS_PASSPORT_I_COUNTRY: ['P'],
		IS_PHOTO_I_STATE: ['L', 'U'],
		IS_DRIVER_I_STATE: ['RD', 'BD'],
		IS_ISSUE_STATE: ['BT', 'RT'],
		IS_NATURALIZATION: ['C', 'B'],
		IS_NOT_USA_ISSUING_COUNTRY: ['P', 'I', 'X', 'E', 'Z', 'L','U']
	},
	IP_ADDRESS: '0.0.0.0',
	LANGUAGES: {
		ENGLISH: 'EN',
		ENGLISH_CODE: 'en_US'
	},
	LOCAL_STORAGE_KEYS: {
		MOBILE_AD_MODAL: 'olci_mobileAd'
	},
	MINOR_ADULT_AGE_THRESHOLD: 16,
	MICROSERVICE_RESPONSE_STATUS: {
		SUCCESSFUL_REQUEST: 200,
		FAILURE: 'failure'
	},
	MODAL: {
		LANGUAGE: 'modalLanguage',
		EMAIL_CTC: 'emailCtc',
		EXIT: 'modalExitConfirmation',
		CRUISE_HISTORY: 'cruiseHistory',
		CURRENCY_CONVERSION_PROGRAM: 'currencyConversionProgram',
		MOBILE_APP_BANNER: 'mobileAppBanner',
		BIOMETRICS_PRIVACY1: 'biometricsPrivacy1',
		BIOMETRICS_PRIVACY2: 'biometricsPrivacy2',
		TERMS_OF_USE: 'termsOfUse',
		HEALTH_SAFETY_PROTOCOLS: 'healthSafetyProtocols',
		VACCINATION_REMINDER: 'vaccinationReminder',
	},
	MODULES_NAMES: {
		ADDRESS_CONTACT: 'addressContact',
		ARRIVAL_TIMES: 'arrivalTimes',
		CONTACT_INFO: 'contactInfo',
		CRUISE_CONTRACT: 'cruiseContract',
		EMERGENCY_CONTACT: 'emergencyContact',
		EXPENSE_ACCOUNT: 'expenseAccount',
		EXPRESS_PASS_SMARTSHIPS: 'expressPassSmartShips',
		HEALTH_RISK_ACKNOWLEDGEMENT: 'healthRiskAcknowledgement',
		IMMIGRATION_INFO: 'immigrationInfo',
		PERSONAL_DETAIL: 'personalDetails'
	},
	OLCI_BREAKPOINTS: {
		PHONE: 771, // for SSP only.
		TABLET: 1200
	},
	OLCI_STATUS: {
		REPRINT: 'REPRINT',
		COMPLETED: 'COMPLETED',
		NOT_STARTED: 'NOT_STARTED',
		IN_PROGRESS: 'IN_PROGRESS'
	},
	ONBOARD_EXPENSE_CREDIT_CARD_FORM: {
		DISPLAY_CC_FORM: 'add',
		EDIT_CC_FORM: 'edit',
		HIDE_CC_FORM: ''
	},
  ONBOARD_EXPENSE_CREDIT_CARD_AUTHORIZATION: {
    CURRENCY_CODE: 'USD',
    AMOUNT: 1,
  },
	OS_TYPE: {
		IOS: 'IOS',
		ANDROID: 'ANDROID'
	},
	PAGE_NAME_FOR_TRACKING: {
		SSP: 'setsailpass',
		BOARDING_PASS: 'boardingpass',
		GUEST_DETAILS: 'guest:guestdetails',
		READY_TO_BOARD: 'checkin:readytoboard',
		HEALTH_CENTER: 'healthcenter',
		CHECK_IN_HEALTH_CENTER: 'checkin:healthcenter',
		ONBOARD_EXPENSES: 'expenses',
	},
	PAYMENT_GATEWAY: {
		ROYAL_CHANNEL: 'OLCI_ROYAL_WEB',
		CELEBRITY_CHANNEL: 'OLCI_CELEBRITY_WEB',
		EVENT_TOKENIZATION: 'transaction-tokenization',
		EVENT_ERROR: 'transaction-error',
		EVENT_DECLINED: 'transaction-declined',
		EVENT_FORM_FIELD_CHANGE: 'form-field-change',
		EVENT_FORM_FIELD: {
			CREDIT_CARD_NUMBER: 'cardNumber',
			CARDHOLDER: 'cardholder',
			EXPIRATION_DATE: 'expirationDate',
      SECURITY_CODE: 'securityCode',
      ZIP_CODE: 'zipCode',
		},
    SELECTOR_FORM_FIELD: {
      CARD_HOLDER: '#cardholderName',
      ZIP_CODE: '#zipCode',
    },
		CREDIT_CARD_BRAND: {
			AMEX: 'American Express',
			MASTERC: 'Mastercard',
			VISA: 'Visa',
			DISCOVER: 'Discover',
			JCB: 'Japan Credit Bureau',
			DINERS_CLUB: 'Diners Club'
		},
		ENV: {
			DEVELOPMENT: 'development',
			STAGE: 'stage',
			PRODUCTION: 'production'
		},
		COMPONENT_LOADED: 'component-loaded'
	},
	PAYMENT_TYPE: {
		CASH: 'CA',
		NO_CHARGING_PRIVILEGES: 'NO'
	},
	PHOTO_DIMENSIONS: {
		WIDTH: 960,
		HEIGHT: 960
	},
	RESPONSIVE_VIEW_APP_STORE_URL: {
		ROYAL: {
			MOBILE_AD_MODAL: {
				IOS: 'https://itunes.apple.com/us/app/royal-caribbean-international/id1260728016?mt=8',
				ANDROID: 'https://play.google.com/store/apps/details?id=com.rccl.royalcaribbean&hl=en'
			},
			BOARDING_PASS: {
				IOS: 'https://itunes.apple.com/us/app/royal-caribbean-international/id1260728016?mt=8',
				ANDROID: 'https://play.google.com/store/apps/details?id=com.rccl.royalcaribbean&hl=en'
			}
		},
		CELEBRITY: {
			MOBILE_AD_MODAL: {
				IOS: 'https://itunes.apple.com/us/app/celebrity-cruises/id1313008863?mt=8',
				ANDROID: 'https://play.google.com/store/apps/details?id=com.rccl.celebrity&hl=en_US'
			},
			BOARDING_PASS: {
				IOS: 'https://itunes.apple.com/us/app/celebrity-cruises/id1313008863?mt=8',
				ANDROID: 'https://play.google.com/store/apps/details?id=com.rccl.celebrity&hl=en_US'
			}
		}
	},
	ROUTES: {
		ARRIVAL_INFO: '/guest/arrivalinfo',
		BOARDING_PASS: '/boardingpass',
		CONFIRMATION_PAGE: '/confirmation',
		CRUISE_DETAILS: '/guest/cruisedetails',
		ERROR: '/error',
		GUEST_DETAILS: '/guest/guestdetails',
		GUEST_ACCOUNT: '/account',
		ONBOARD_EXPENSE: '/guest/onboardexpenses',
		SEARCH_MINORS: '/associatedsearch',
		SELECT_GUESTS_FOR_CHECKIN: '/selectforcheckin',
		HEALTH_CENTER: '/healthcenter',
		NEW_GUEST_ACCOUNT: '/myaccount',
		SIGN_IN: '/signin'
	},
	ANALYTICS_LOCATIONS: {
		LANDING_PAGE: 'CheckinLandingPage',
		LANDING_PAGE_POPUP: 'CheckinLandingPage_Popup',
		BOARDING_PASS: 'CheckinBoardingPassPage',
		ARRIVAL_TIMES: 'CheckinArrivalTimePage',
		CRUISE_CONTRACT: 'CheckinCruiseContractPage',
		READY_TO_BOARD_POP_UP: 'CheckingReadyToBoardPop-up',
		ONBOARD_EXPENSES: 'CheckinOnboardExpenses'
	},
	INTERACTIONS: {
		HEALTH_CENTER_CLICK: 'checkin:healthcenter:click',
		HEALTH_CENTER_EXTERNAL_LINK_CLICK: 'checkin:externallink:'
	},
	LOGIN_STATUS: {
		LOGGED_IN: 'Logged In',
	},
	PLATFORMS: {
		MOBILE: 'Mobile',
		WEB: 'Web'
	},
	SESSION_STORAGE_KEYS: {
		OLCI_RESERVATION_DATA: 'OLCI_RESERVATION_DATA',
		OLCI_LOGGED_IN_GUEST_ID: 'OLCI_LOGGED_IN_GUEST_ID',
		TIMEOUTMOCK_MILLISECONDS: 'TIMEOUTMOCK_MILLISECONDS',
		COOKIE_NULL_VALUES_ERROR_LOGGED: 'COOKIE_NULL_VALUES_ERROR_LOGGED',
		MOCK_ID: 'MOCK_ID',
		MOCK_GROUP_INDEX: 'MOCK_GROUP_INDEX',
		PREVIOUS_PAGE: 'previous-page',
		SCREEN_WIDTH: 'screenwidth',
		GUESTS: 'guests',
	},
	SOURCE: 'Web',
	TRAVEL_DOCUMENT: {
		ISSUING_STATE: ['R', 'B'],
		DRIVER_LICENSE_STATE: ['L', 'D', 'T', 'U']
	},
	TRAVEL_QUESTIONNAIRE: {
		YES: 'Yes',
		NO: 'No'
	},
	USA_BOOKING_OFFICES: ['USA', 'MIA'],
	VALIDATION_REGEX: {
		EMAIL:
			// tslint:disable-next-line: max-line-length
			'^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'
	},
	ADVERTISEMENT: {
		PAGE_ID: '2209',
		TRACKING: {
			CLICK: 'click',
			VIEW: 'view'
		},
	},
	GRAPHQL: {
		QUERIES:{
			ADVERTISEMENT: {
				GET_ADS: `query MobileAppAdvertisementByPageId(
							$contextUrl: String,
							$sessionCookie: String!,
							$pageId: String!,
							$userId: String
						) {
							advertisementByPageId(
							contextUrl: $contextUrl,
							pageId: $pageId,
							sessionCookie: $sessionCookie,
							userId: $userId
							) {
							mainText
							secondaryText
							adSize
							secondaryImage
							mainUrl
							mainImage
							actionId
							route
							adLabel
							discountSavingsRate
							campaignDescription
							mobileImage
							}
						}
						`,
						TRACKING_ADS: `query MobileAppAdvertisementTracking(
											$sessionCookie: String!,
											$pageId: String!,
											$action: String!,
											$trackingId: String
											){
											userTracking(
												sessionCookie: $sessionCookie,
												pageId: $pageId,
												action: $action,
												trackingId: $trackingId
											) {
												status
											}
										}
									`
			}
		}
	},
	RADIO_BUTTON_DIRECTION: {
		HORIZONTAL: 'row',
		VERTICAL: 'column',
	}
};
